export const BLUEPRINTS_ROOT = '/asset-catalog/blueprints';
